import React from 'react';

export const Loader:React.FC = () => (
  <div className="myinterview-widget-loader">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 53.6 50.6"
      version="1.1"
      viewBox="0 0 53.6 50.6"
      xmlSpace="preserve"
      fill="currentColor"
    >
      <g>
        <path
          d="M53.1 11.6c-.8-5-2.6-7.7-6.1-9.5C44.2.6 32.5-.1 26.2 0 19.9 0 9.4.6 6.6 2.1 3.1 3.9 1.3 6.6.5 11.6c-.4 3.2-.5 6.3-.5 9.5s.1 6.3.5 9.5c.8 5 2.6 7.7 6.1 9.5 2.8 1.5 13.3 2.2 19.6 2.1h.7l-2.6-7.1c-4.6 0-11.4.1-13-.6-2.3-1-3.5-2.8-3.9-6.4-.2-1.6-.2-5-.2-6.9s0-5.4.2-7c.4-3.7 1.5-5.4 3.9-6.4 1.8-.9 10.7-.7 15.1-.8s14.1-.2 15.9.6c2.3 1 3.5 2.8 3.9 6.4.2 1.6.2 5.1.2 6.9s0 5.4-.2 7c-.4 3.7-1.5 5.4-3.9 6.4-1.3.6-6.8.6-11.4.6l.3.8 5.5 14.7 4.2-9.2c2.1-.1 4.2-.6 6.1-1.4 3.5-1.8 5.3-4.5 6.1-9.5.3-3.2.5-6.3.5-9.5 0-2.9-.1-6-.5-9.2"
          className="st0"
        />
      </g>
    </svg>
  </div>
);
